import * as React from "react";

const TextInput = (props) => {
  return <input type="text" {...props} />;
};

export default TextInput;
